export const COLORS = {
  PRIMARY: "#4472b4",
  BLACK: "#000000",
  WHITE: "#ffffff",
  NAVY_BLUE: "#0059b3",
};
